import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from '@/store'
import router from '@/router'

const instance = axios.create({
  baseURL: process.env.VUE_APP_baseURL,
  timeout: 60000,
  withCredentials: true,
})

instance.interceptors.request.use(
  function (config) {
    config.headers['V2-Request'] = 1
    if (!config.disable_loading) {
      store.dispatch('loading', true)
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  function (response) {
    let { config } = response
    config = Object.assign({ messageError: true }, config)
    if (!config.disable_loading) {
      store.dispatch('loading', false)
    }
    if (['blob', 'arraybuffer'].includes(response.config.responseType)) {
      return response
    }
    if (response.data.state === undefined && response.data.code === undefined) {
      config.messageError &&
        ElMessage({
          type: 'error',
          message: '请求失败',
        })
      return Promise.reject(response)
    } else if (response.data.state !== undefined && response.data.state !== 1) {
      config.messageError &&
        ElMessage({
          type: 'error',
          message: response.data.info ?? '请求失败',
        })
      if (
        response.data.state === 2 &&
        !response.config.routerBefore &&
        router.currentRoute.value.fullPath !== '/'
      ) {
        router.replace({
          path: '/login',
          query: { redirect: router.currentRoute.value.fullPath },
        })
      }
      return Promise.reject(response)
    } else if (response.data.code !== undefined && response.data.code !== 0) {
      config.messageError &&
        ElMessage({
          type: 'error',
          message: response.data.msg ?? '请求失败',
        })
      return Promise.reject(response)
    }
    if (
      response.config?.messageSuccess &&
      response.data.state === 1 &&
      response.data.info
    ) {
      ElMessage({
        type: 'success',
        message: response.data.info,
      })
    }
    return response
  },
  function (error) {
    store.dispatch('loading', false)
    const excludeCode = ['ERR_CANCELED']
    !excludeCode.includes(error.code) &&
      ElMessage({
        type: 'error',
        message: error.response?.data?.message ?? error.message ?? '请求失败',
      })
    return Promise.reject(error)
  }
)

export default instance
